import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { useEffect, useContext } from 'react';

export const usePingAdminRequests = () => {
  const {
    mobxStore: { authStore, adminRequestsStore },
  } = useContext(MobxContext);
  const user = authStore.user;
  const isAdmin = user?.isAdmin;

  useEffect(() => {
    if (!isAdmin) {
      return;
    }

    const ping = async () => {
      try {
        await adminRequestsStore.silenceFetch();
      } catch (e) {
        console.error(e);
      }
    };
    ping();

    const interval = setInterval(async () => {
      ping();
    }, 5000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [adminRequestsStore, isAdmin]);
};
